import { memo, useState } from "react";
import CompleteDropdown from "../../shared/Dropdown/CompleteDropdown";
import { Dropdown, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperPlane,
  faCircleCheck,
  faBan,
  faRecycle,
  faPlayCircle,
  faStopCircle,
  faLightbulb,
  faDisplay,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import ImagesPreview from "./Previews/ImagesPreview";
import { formatDate } from "@serie3/common/Shared/timeingStuff";
import StatsOverview from "./Posts/StatsOverview";

const Timelineitem = ({
  post,
  editAction,
  deleteAction,
  publish,
  setDraftAction,
  creatVariantsAction,
  markInProgress,
  createIdeasAction,
  schedule = null,
  telepromterAction,
  shareAction,
}) => {
  const statusBarColor = post.schedules?.some(
    (s) => (s.post_status || "scheduled") === "published"
  )
    ? "#51d28c"
    : "#038edc";
  const [postFiles] = useState([]);

  const timelineContainerStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "10px", // Adjust the gap between timeline items as needed
  };

  const timelineItemStyle = {
    display: "flex",
    justifyContent: "space-between", // Ensure content is spaced correctly
    alignItems: "center",
  };

  const timelineContentStyle = {
    textAlign: "right", // Ensure text is aligned to the left within the content area
    flex: 1,
  };


  const { t } = useTranslation();

  const Tags = ({ post }) => {
    return (
      <>
        {(() => {
          let tags = [];

          if (post.draft) {
            // Highest priority: Draft status
            tags.push(
              <span
                key="draft"
                className="badge-primary-subtle font-size-12 badge bg-link rounded-pill me-3"
              >
                {t("Backend.Post.State.Draft")}
              </span>
            );
          } else {
            tags.push(
              <span
                key="ready"
                className="badge-warning-subtle font-size-12 badge bg-link rounded-pill me-3"
              >
                {t("Backend.Post.State.Ready")}
              </span>
            );
          }

          if (post.schedules && post.schedules.length > 0) {
            // Track already added statuses to avoid duplicates
            const addedStatuses = new Set();

            for (const schedule of post.schedules) {
              const status = schedule.post_status || "scheduled";

              // Skip if the status has already been added
              if (!addedStatuses.has(status)) {
                const capitalizedStatus =
                  status.charAt(0).toUpperCase() + status.slice(1);

                const badgeClass =
                  status === "published"
                    ? "badge-success-subtle"
                    : status === "scheduled"
                    ? "badge-warning-subtle"
                    : status === "ready"
                    ? "badge-light-subtle"
                    : status === "error"
                    ? "badge-danger-subtle"
                    : "badge-secondary-subtle";


                tags.push(
                  <span
                    key={schedule.id}
                    className={`badge me-3 font-size-12 badge bg-link rounded-pill ${badgeClass}`}
                  >
                    {t(`Backend.Post.State.${capitalizedStatus}`)}
                  </span>
                );

                addedStatuses.add(status);
              }
            }
          }

          return tags.length > 0 ? tags : null;
        })()}
      </>
    );
  };

  let postType = post.post_type
    ? "Backend.Post.PostType." + post.post_type
    : "Backend.Post.PostType.Text";
  let contentType = post.content_type
    ? "Backend.Post.ContentType." + post.content_type
    : "Backend.Post.ContentType.Personal";

  return (
    <div className="timeline-item">
      <div className="timeline-block">
        <div
          className="timeline-box card"
          style={{ borderLeft: "2px solid " + statusBarColor }}
        >
          <div className="card-header">
            <h5>
              {schedule &&
                schedule.post_status &&
                schedule.post_status === "error" && (
                  <span
                    key={schedule.id}
                    className={`badge me-3 font-size-14 badge bg-link rounded-pill badge-danger-subtle`}
                  >
                    {t(`Backend.Post.State.Error`)}
                  </span>
                )}
              {post.title}
              <span className="pb-3">
                <CompleteDropdown
                  deleteAction={schedule ? null : deleteAction}
                  editAction={editAction}
                >
                  {!post.draft ? (
                    <Dropdown.Item
                      onClick={() => {
                        setDraftAction();
                      }}
                      className="text-danger"
                    >
                      <FontAwesomeIcon icon={faBan} className="fs-6 me-2" />
                      {t("Backend.Post.SetDraft")}
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item
                      onClick={() => {
                        setDraftAction();
                      }}
                      className="text-success"
                    >
                      <FontAwesomeIcon
                        icon={faCircleCheck}
                        className="fs-6 me-2"
                      />
                      {t("Backend.Post.SetReady")}
                    </Dropdown.Item>
                  )}
                  <div className="dropdown-divider" />
                  {!post.in_progress ? (
                    <Dropdown.Item
                      onClick={() => {
                        markInProgress();
                      }}
                      className="text-success"
                    >
                      <FontAwesomeIcon
                        icon={faPlayCircle}
                        className="fs-6 me-2"
                      />
                      {t("Backend.Post.SetInProgress")}
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item
                      onClick={() => {
                        markInProgress();
                      }}
                      className="text-danger"
                    >
                      <FontAwesomeIcon
                        icon={faStopCircle}
                        className="fs-6 me-2"
                      />
                      {t("Backend.Post.SetNotInProgress")}
                    </Dropdown.Item>
                  )}
                  {!post.draft && (
                    <>
                      <div className="dropdown-divider" />
                      <Dropdown.Item
                        onClick={() => {
                          publish(post.id);
                        }}
                        className="text"
                      >
                        <FontAwesomeIcon
                          icon={faPaperPlane}
                          className="fs-6 me-2"
                        />
                        {t("Backend.Post.Publish")}
                      </Dropdown.Item>
                    </>
                  )}
                  <div className="dropdown-divider" />
                  <Dropdown.Item
                    onClick={() => {
                      creatVariantsAction();
                    }}
                  >
                    <FontAwesomeIcon icon={faRecycle} className="fs-6 me-2" />
                    {t("Backend.Post.Variants.Create")}
                  </Dropdown.Item>
                  <div className="dropdown-divider" />
                  <Dropdown.Item
                    onClick={() => {
                      createIdeasAction();
                    }}
                  >
                    <FontAwesomeIcon icon={faLightbulb} className="fs-6 me-2" />
                    {t("Backend.Post.Variants.Ideas")}
                  </Dropdown.Item>

                  <div className="dropdown-divider" />
                  <Dropdown.Item
                    onClick={() => {
                      telepromterAction(post);
                    }}
                    className="text"
                  >
                    <FontAwesomeIcon icon={faDisplay} className="fs-6 me-2" />
                    {t("Backend.Post.Teleprompter.NavigationTitle")}
                  </Dropdown.Item>

                  <div className="dropdown-divider" />
                  <Dropdown.Item
                    onClick={() => {
                      shareAction(post.id);
                    }}
                    className="text"
                  >
                    <FontAwesomeIcon icon={faShare} className="fs-6 me-2" />
                    {t("Backend.Post.ShareInGroup")}
                  </Dropdown.Item>
                </CompleteDropdown>
              </span>
            </h5>
            <Row>
              <Col>
                <small>
                  {schedule &&
                    ((schedule.post_status &&
                      schedule.post_status === "published") ||
                    schedule.post_status === "error" ? (
                      <>
                        {t("Backend.Post.State.PublishedAt")}{" "}
                        {formatDate(schedule.posted_at)} {schedule.timezone}
                      </>
                    ) : (
                      <>
                        {t("Backend.Post.State.ScheduledFor")}{" "}
                        {formatDate(schedule.scheduled_for)} {schedule.timezone}
                      </>
                    ))}
                </small>
              </Col>
              <Col>
                <StatsOverview post={post} />
              </Col>
            </Row>
          </div>
          <div className="card-body">
            <Row>
              <Col md={8}>
                <div style={timelineContainerStyle}>
                  <div style={timelineItemStyle}>
                    <div style={timelineContentStyle}></div>
                  </div>
                </div>
                <div className="text-muted">
                  <p className="mb-0" style={{ whiteSpace: "pre-line" }}>
                    {post.text && (post.text.length > 400 ? post.text.slice(0, 400) + "..." : post.text)}
                  </p>
                </div>
                <ImagesPreview postFiles={postFiles} post={post} />
              </Col>
            </Row>
          </div>
          <div className="card-footer">
            <span
              className={`badge me-3 font-size-12 badge bg-link rounded-pill badge-info-subtle`}
            >
              {t(contentType)}
            </span>
            <span
              className={`badge me-3 font-size-12 badge bg-link rounded-pill badge-success-subtle`}
            >
              {t(postType)}
            </span>
            <Tags post={post} />
          </div>
        </div>
      </div>
    </div>
  );
};

// Custom comparator: function props are recreated on every parent render
// (TimnelineTab builds new per-row closures in its .map). Comparing only the
// data props means a row only re-renders when its underlying post/schedule
// actually changes — not when the modal opens or autosave fires.
const areEqual = (prev, next) =>
  prev.post === next.post && prev.schedule === next.schedule;

export default memo(Timelineitem, areEqual);
